import { GeneralAgentLauncher } from '@/features/general-agent'
import { CallWidgets } from './components/call-widgets'

export const SharedWidgets = () => {
    return (
        <>
            <CallWidgets />
            <GeneralAgentLauncher />
        </>
    )
}
